import {
  loginByUsername,
  logout,
  getUserInfo,
  getTutorAllScore,
  getEntryKey,
  getUserMoreInfo
} from '@/api/user'
import { TutorSelfCancel,GetTeacherToken } from '@/api/classtable'
import { getTutorTrail } from '@/api/tutordata'
import { getSelfScheduleLimitCheck } from '@/api/releaseTime'
import { getTutorHomeTask, growthSystemIsFirstLogin, getGradeHonorDetail, getMedalDetail, getMilestoneList, getPetInfo, requestLog, updateLogTime } from '@/api/dashboard'
import { addTuModelClickLog } from '@/api/system'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import dfAvatar from '@/assets/img/common/acadsoc.jpg'
import specialMedal1 from '@/assets/img/dashboard/growth-system/special-dark-1.png'
import specialMedal2 from '@/assets/img/dashboard/growth-system/special-dark-2.png'
import specialMedal3 from '@/assets/img/dashboard/growth-system/special-dark-3.png'
import specialMedal4 from '@/assets/img/dashboard/growth-system/special-dark-4.png'
const user = {
  state: {
    tuid: 0,
    account: '',
    avatar: '',
    defaultAvatar: dfAvatar,
    firstName: '',
    lastName: '',
    fullName: '',
    sex: '0',
    birthday: '',
    email: '',
    excellentType: 0,
    internetSpeed: 0,
    school: 0,
    location: '',
    city: '',
    provice: '',
    tutoringEquipment: 0,
    intServiceProvider: 0,
    netConnType: 0,
    integralLevel: 0,
    selfIntrodction: '',
    flowers: 0,
    scoreMonth: '',
    scoreOfTheMonth: 0,
    teachingPoints: 0,
    completion: 0,
    goodRating: 0,
    absences: 0,
    badRating: 0,
    cancellation: 0,
    isFirstLogin: false,
    isNeedRedirectDegree: false,
    isNeedUpdatePhone: false,
    isNeedToImprovePersonalInformation: false,
    other: 0,
    status: '',
    code: '',
    tutorGroup: 0,
    token: getToken(),
    expiresTime: 0,
    roles: [],
    openSelfSchedule: false,
    openSelfCancel: false,
    disableComment: '',
    setting: {},
    transformPeriodCount: 0,
    limitRefferal: false,
    limitCheck: null,
    auditFailure: {
        dialog: false,
        text: ""
    },
    authStr:'',
    isCustomized:false,
    isShowAppFloatingIcon: false,
    entryKey:'',
    awaitApproval:false,
    retrieveEmail: {
      email: '',
      step:  1
    },
    showDashboardRank: false,
    sidebarMenuMini: true,
    feedBackMsg:false,
    isGrowthSystemTestGroup: false,
    growthSystemLevel: 0,
    growthSystemScore: 0,
    growthSystemUnclaimedPoints: 0,
    growthSystemRemainingPoints: 0,
    growthSystemMedalList: [],
    growthSystemLevelMedal: [],
    growthSystemTaskList: [],
    growthSystemJoinDay: 0,
    growthSystemMilestoneList:[],
    isFirstGrowthSystemLogin: false,
    isUpGrade:false,
    petInfo:{
      AlterNum: 0,
      IsAdopt: null,
      IsCanModified: null,
      PetLevel: 0,
      PetName: ""
    },
    isFranchiseeUser:false,
    specialMedal1,
    specialMedal2,
    specialMedal3,
    specialMedal4,
    isInternationalOrCustom:0,//0国际老师 1定制老师,
    isPassedTL:false,
    specialAchiMedals:{
      dialog:false
    },
    isTuEyeProtectionMode: 0, //是否为护眼模式
    isShowChristmasDialog: false, //是否显示圣诞活动弹层
    actoken:''
  },

  mutations: {
    SET_ENTRY_KEY:(state,key)=>{
        state.entryKey=key
    },
    SET_AUTH_STR:(state,authStr)=>{
        state.authStr=authStr
    },
    SET_AUDIT_FAILURE:(state,failure)=>{
        state.auditFailure=failure
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRETIME: (state, expireIn) => {
      var currDate = new Date()
      state.expiresTime = currDate.setTime(currDate.getTime() + 1000 * expireIn)
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_TUID: (state, tuid) => {
      state.tuid = tuid
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account
    },
    SET_OPENSELFSCHEDULE: (state, openSelfSchedule) => {
      state.openSelfSchedule = openSelfSchedule
    },
    SET_OPENSELFCANCEL: (state, openSelfCancel) => {
      state.openSelfCancel = openSelfCancel
    },
    SET_DISABLECOMMENT: (state, disableComment) => {
      state.disableComment = disableComment
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_FIRSTNAME: (state, firstName) => {
      state.firstName = firstName
    },
    SET_LASTNAME: (state, lastName) => {
      state.lastName = lastName
    },
    SET_FULLNAME: (state, fullName) => {
      state.fullName = fullName
    },
    SET_SEX: (state, sex) => {
      state.sex = sex + ''
    },
    SET_BIRTHDAY: (state, birthday) => {
      state.birthday = birthday
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_EXCELLENT_TYPE: (state, excellentType) => {
      state.excellentType = excellentType
    },
    SET_INTERNETSPEAD: (state, interNetSpead) => {
      state.internetSpeed = interNetSpead
    },
    SET_SCHOOL: (state, school) => {
      state.school = school
    },
    SET_LOCATION: (state, location) => {
      state.location = location
    },
    SET_CITY: (state, city) => {
      state.city = city
    },
    SET_PROVICE: (state, provice) => {
      state.provice = provice
    },
    SET_TUTORINGEQUIPMENT: (state, tutorIngEquipment) => {
      state.tutorIngEquipment = tutorIngEquipment
    },
    SET_INTSERVICEPROVIDER: (state, intServiceProvider) => {
      state.intServiceProvider = intServiceProvider
    },
    SET_NETCONNTYPE: (state, netConnType) => {
      state.netConnType = netConnType
    },
    SET_INTEGRALLEVEL: (state, integralLevel) => {
      state.integralLevel = integralLevel
    },
    SET_SELFINTRODCTION: (state, selfIntrodction) => {
      state.selfIntrodction = selfIntrodction
    },
    SET_FLOWERS: (state, flowers) => {
      state.flowers = flowers
    },
    SET_SCOREOFTHEMONTH: (state, scoreOfTheMonth) => {
      state.scoreOfTheMonth = scoreOfTheMonth
    },
    SET_TEACHINGPOINTS: (state, teachingPoints) => {
      state.teachingPoints = teachingPoints
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_COMPLETION: (state, score) => {
      state.completion = score
    },
    SET_GOODRATIONG: (state, score) => {
      state.goodRating = score
    },
    SET_ABSENCES: (state, score) => {
      state.absences = score
    },
    SET_BADRATIONG: (state, score) => {
      state.badRating = score
    },
    SET_CANCELLATION: (state, score) => {
      state.cancellation = score
    },
    SET_SCOREMONTH: (state, month) => {
      state.scoreMonth = month
    },
    SET_OTHER: (state, score) => {
      state.other = score
    },
    SET_ISFIRSTLOGIN: (state, isFirstLogin) => {
      state.isFirstLogin = isFirstLogin
    },
    SET_ISNEEDREDIRECTDEGREE: (state, isNeedRedirectDegree) => {
      state.isNeedRedirectDegree = isNeedRedirectDegree
    },
    SET_ISNEEDUPDATEPHONE: (state, isNeedUpdatePhone) => {
      state.isNeedUpdatePhone = isNeedUpdatePhone
    },
    SET_ISNEEDTOIMPROVEPERSONALINFORMATION: (state, isNeedToImprovePersonalInformation) => {
      state.isNeedToImprovePersonalInformation = isNeedToImprovePersonalInformation
    },
    SET_TUTORGROUP: (state, tutorGroup) => {
      state.tutorGroup = tutorGroup
    },
    SET_TRANSFORMPERIODCOUNT: (state, transformPeriodCount) => {
      state.transformPeriodCount = transformPeriodCount
    },
    SET_LIMITREFERRAL: (state, limitRefferal) => {
      state.limitRefferal = limitRefferal
    },
    GETLIMIT: (state, array) => {
      state.limitCheck = array
    },
    SET_ISCUSTOMIZED: (state ,isCustomized) => {
      state.isCustomized = isCustomized
    },
    SET_ISSHOWAPPFLOATINGICON: (state ,isShowAppFloatingIcon) => {
      state.isShowAppFloatingIcon = isShowAppFloatingIcon
    },
    SET_AWAITAPPROVAL: (state ,awaitApproval) => {
      state.awaitApproval = awaitApproval
    },
    SET_IS_RETRIEVE_EMAIL: (state, type) => {
      state.retrieveEmail = type
    },
    SET_DASHBOARD_RANK: (state, res) => {
      state.showDashboardRank = res
    },
    SET_SIDE_BAR_MINI:(state, res) => {
      state.sidebarMenuMini = res
    },
    SET_GROWTHSYSTEM: (state, res) => {
      state.isGrowthSystemTestGroup = res
    },
    SET_GROWTH_SYSTEM_LEVEL:(state, res) => {
      state.growthSystemLevel = res
    },
    SET_GROWTH_SYSTEM_SCORE:(state, res) => {
      state.growthSystemScore = res
    },
    SET_GROWTH_SYSTEM_UNCLAIMED_POINTS:(state, res) => {
      state.growthSystemUnclaimedPoints = res
    },
    SET_GROWTH_SYSTEM_REMAINING_POINTS:(state, res) => {
      state.growthSystemRemainingPoints = res
    },
    SET_GROWTH_SYSTEM_MEDAL_LIST:(state, res) => {
      state.growthSystemMedalList = res
    },
    SET_GROWTH_SYSTEM_LEVEL_MEDAL:(state, res) => {
      state.growthSystemLevelMedal = res
    },
    SET_GROWTH_SYSTEM_TASK_LIST:(state, res) => {
      state.growthSystemTaskList = res
    },
    SET_GROWTH_SYSTEM_JOIN_DAY:(state, res) => {
      state.growthSystemJoinDay = res
    },
    SET_GROWTH_SYSTEM_MILESTONE_LIST:(state, res)=>{
      state.growthSystemMilestoneList = res
    },
    SET_GROWTH_SYSTEM_IS_FIRST_LOGIN:(state, res) => {
      state.isFirstGrowthSystemLogin = res
    },
    SET_IS_UP_GRADE:(state,res)=>{
      state.isUpGrade = res
    },
    SET_GET_PET_INFO:(state,res)=>{
      state.petInfo = res
    },
    SET_IS_FRASHISEE_USER:(state,res)=>{
      state.isFranchiseeUser = res
    },
    SET_IS_INTERNATIONAL_OR_CUSTOM:(state,res)=>{
      state.isInternationalOrCustom = res
    },
    IS_PASSED_TL:(state,res)=>{
      state.isPassedTL = res
    },
    SET_SPECIAL_ACHI_MEDALS:(state,res)=>{
      state.specialAchiMedals.dialog = res
    },
    SET_TU_EYE_PROTECTION_MODE:(state,res)=>{
      state.isTuEyeProtectionMode = res
    },
    SET_CHRISTMAS_DIALOG:(state,res)=>{
      state.isShowChristmasDialog = res
    },
    SET_AC_TOKEN:(state,token)=>{
      state.actoken = token
    },
    SET_FEED_BACK_MSG:(state,MsgDialog)=>{
      state.feedBackMsg = MsgDialog
    },
  },
  actions: {
    setEntryKey({commit}){
        return new Promise((resolve,reject)=>{
            getEntryKey().then(key=>{
                commit("SET_ENTRY_KEY",key)
                resolve(key)
            })
        })
    },
    setAcToken({commit,state}){
        return new Promise((resolve,reject)=>{
            if(state.actoken){
                resolve(state.actoken)
                return
            }
            GetTeacherToken().then(res=>{
                if(res.token){
                    commit("SET_AC_TOKEN",res.token)
                }

                console.log('客户端参数：',JSON.stringify({
                    TUID:state.tuid,
                    Token:res.token
                }))
                if(window.GetTeachUserData){
                  if(state.tuid && state.tuid>0){
                    console.log('调用window.GetTeachUserData上传参数给客户端')
                    window.GetTeachUserData(JSON.stringify({
                        TUID:state.tuid,
                        Token:res.token
                    }));
                  }
                }else{
                    console.log('window.GetTeachUserData客户端方法不存在')
                }

                resolve(res)
            })
        })
    },
    setAuthStr({commit},authStr){
        commit("SET_AUTH_STR",authStr);
    },
    setFailure({commit},failure){
        commit("SET_AUDIT_FAILURE",failure)
    },
    SetIntegralLevel ({
      commit
    }, level) {
      commit('SET_INTEGRALLEVEL', level)
    },
    // 用户名登录
    LoginByUsername ({
      commit
    }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password).then(data => {
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginAuto ({
      commit
    }, authInfo) {
      return new Promise((resolve, reject) => {
        commit('SET_ROLES', [])
        commit('SET_TOKEN', authInfo.access_token)
        commit('SET_EXPIRETIME', authInfo.expires_in)
        setToken(authInfo.access_token)
        if (!getToken()) {
          reject(new Error('Token is Empty, Login Fail.'))
        }
        resolve()
      })
    },
    async LoginThree ({
      commit
    }, authInfo) {
      const _token = await new Promise((resolve, reject) => {
        commit('SET_TOKEN', authInfo.access_token)
        commit('SET_EXPIRETIME', authInfo.expires_in || 0)
        setToken(authInfo.access_token)
        resolve(authInfo.access_token)
      }).then(token => {
        return token
      })
      return _token
    },
    // 用户分数
    GetUserAllScore ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getTutorAllScore().then(data => {
          commit('SET_FLOWERS', data.Flowers)
          commit('SET_SCOREOFTHEMONTH', data.MonthScore)
          commit('SET_TEACHINGPOINTS', data.TeachingPoints)
          commit('SET_COMPLETION', data.ComScore)
          commit('SET_GOODRATIONG', data.GoodScore)
          commit('SET_ABSENCES', data.AbsentScore)
          commit('SET_BADRATIONG', data.BadScore)
          commit('SET_CANCELLATION', data.CancelScore)
          commit('SET_OTHER', data.OtherScore)
          commit('SET_SCOREMONTH', data.Month)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetOpenSelfCacel ({
      commit
    }) {
      TutorSelfCancel().then(result => {
        commit('SET_OPENSELFCANCEL', result)
      }).catch(error => {
        console.log(error)
      })
    },
    // 获取用户信息
    GetUserInfo ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(data => {
          commit('SET_TUID', data.tuid)
          commit('SET_ROLES', ['admin'])
          commit('SET_FULLNAME', data.fullName)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserMoreInfo ({
        commit,
        state
      }) {
        return new Promise((resolve, reject) => {
          getUserMoreInfo(state.token).then(data => {
            commit('SET_ISFIRSTLOGIN', data.isfirstLogin)
            commit('SET_ISNEEDREDIRECTDEGREE', data.isNeedRedirectDegree)
            commit('SET_ISNEEDTOIMPROVEPERSONALINFORMATION', data.isNeedToImprovePersonalInformation)
            commit('SET_ISNEEDUPDATEPHONE', data.isNeedUpdatePhone)
            commit('SET_TUID', data.tuid)
            commit('SET_OPENSELFSCHEDULE', data.openSelfSchedule)
            commit('SET_DISABLECOMMENT', data.disableComment)
            commit('SET_AVATAR', data.avatar)
            commit('SET_FIRSTNAME', data.firstName)
            commit('SET_LASTNAME', data.lastName)
            commit('SET_FULLNAME', data.fullName)
            commit('SET_SEX', data.sex)
            commit('SET_BIRTHDAY', data.birthday)
            commit('SET_EMAIL', data.email)
            commit('SET_INTERNETSPEAD', data.internetSpead)
            commit('SET_SCHOOL', data.school)
            commit('SET_LOCATION', data.location)
            commit('SET_TUTORINGEQUIPMENT', data.tutoringEquipment)
            commit('SET_INTSERVICEPROVIDER', data.intServiceProvider)
            commit('SET_NETCONNTYPE', data.netConnType)
            commit('SET_INTEGRALLEVEL', data.integralLevel)
            commit('SET_SELFINTRODCTION', data.selfIntrodction)
            commit('SET_ACCOUNT', data.account)
            // commit('SET_FLOWERS', data.flowers)
            // commit('SET_SCOREOFTHEMONTH', data.scoreOfTheMonth)
            // commit('SET_TEACHINGPOINTS', data.teachingPoints)
            commit('SET_LOCATION', data.location)
            commit('SET_CITY', data.city)
            commit('SET_PROVICE', data.provice)
            commit('SET_TUTORGROUP', data.tutorGroup)
  
            commit('SET_LIMITREFERRAL', data.limitRefferal)
            commit('SET_ISCUSTOMIZED', data.isCustomized),
            commit('SET_AWAITAPPROVAL',data.awaitApproval)
            commit('SET_ISSHOWAPPFLOATINGICON',data.isShowAppFloatingIcon),
            commit('SET_IS_FRASHISEE_USER',data.isFranchiseeUser)
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },
    GetTutorHomeTask ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getTutorHomeTask().then(data => {
          commit('SET_GROWTHSYSTEM', data.IsTestGroup)  //是否显示成长体系
          commit('SET_GROWTH_SYSTEM_SCORE', data.Score) //分数
          commit('SET_GROWTH_SYSTEM_LEVEL', data.Level) //等级
          commit('SET_GROWTH_SYSTEM_UNCLAIMED_POINTS', data.UnclaimedPoints) //未领取积分
          commit('SET_GROWTH_SYSTEM_REMAINING_POINTS', data.RemainingPoints) //到下一等级需要的积分
          commit('SET_GROWTH_SYSTEM_TASK_LIST', data.TaskList) //任务列表
          commit('SET_GROWTH_SYSTEM_JOIN_DAY', data.JoinDay) //加入天数

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetGradeHonorDetail({
      commit
    }){
      return new Promise((resolve,reject)=>{
        getGradeHonorDetail().then(data=>{
          commit('SET_GROWTH_SYSTEM_LEVEL_MEDAL', data) //等级勋章

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPetInfo({commit}){
      return new Promise((resolve,reject)=>{
        getPetInfo().then(res=>{
          if(res){
            commit('SET_GET_PET_INFO',res)
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // GetMedalDetail({
    //   commit,
    //   state
    // }){
    //   return new Promise((resolve,reject)=>{
    //     getMedalDetail().then(data=>{
    //       const MedalList = data
    //       if(MedalList){
    //         MedalList[0].DarkMedalIcon = state.specialMedal1 //灰色荣誉勋章
    //         MedalList[1].DarkMedalIcon = state.specialMedal2
    //         MedalList[2].DarkMedalIcon = state.specialMedal3
    //         MedalList[3].DarkMedalIcon = state.specialMedal4
    //       }
    //       commit('SET_GROWTH_SYSTEM_MEDAL_LIST', MedalList) //荣誉勋章

    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    GetMilestoneList({
      commit,
      state
    }){
      new Promise((resolve,reject)=>{
        getMilestoneList().then(data=>{
          if(data){
            commit('SET_GROWTH_SYSTEM_MILESTONE_LIST',data)
            resolve()
          }
        }).catch(error=>{
          reject(error)
        })
      })
    },
    GrowthSystemIsFirstLogin ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        growthSystemIsFirstLogin().then(data => {     
          commit('SET_GROWTH_SYSTEM_IS_FIRST_LOGIN', data) 

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 成长体系埋点
    GrowthRequestLog({},res){
      requestLog(res).then(res=>{
      })
    },
    GrowthUpdateLogTime({},res){
      updateLogTime(res)
    },
    UpdateActar ({
      commit
    }, avatar) {
      return new Promise(resolve => {
        commit('SET_AVATAR', avatar)
        resolve()
      })
    },
    // 登出
    LogOut ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_ROLES', [])
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_ROLES', [])
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles ({
      commit
    }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    },

    // 转化课时数
    GetTutorTrail ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getTutorTrail(state.tuid).then(response => {
          commit('SET_TRANSFORMPERIODCOUNT', response.data.Body)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getLimit({commit, state}) {
      return new Promise((resolve,reject)=>{
          if(state.limitCheck&&state.limitCheck.selfSchedulesEnable){
              resolve(state.limitCheck)
          }else{
            getSelfScheduleLimitCheck()
            .then(res => {
              console.log('getSelfScheduleLimitCheck', res)
              commit('GETLIMIT', res)
              resolve(res)
            })
          }
      })
    },
    setExcellentType({commit}, res) {
      commit('SET_EXCELLENT_TYPE', res)
    },
    updateEmail({commit}, res) {
      commit('SET_EMAIL', res)
    },
    setIsRetrieveEmail({commit}, res) {
      commit('SET_IS_RETRIEVE_EMAIL', res)
    },
    setDashboardRank({commit}, res) {
      commit('SET_DASHBOARD_RANK', res)
    },
    setSiderBarMini({commit}, res) {
      commit('SET_SIDE_BAR_MINI', res)
    },
    setFeedBackMsgDialog({commit},res){
          commit('SET_FEED_BACK_MSG',res)
    },
    upGrade({commit},res){
      commit('SET_IS_UP_GRADE',res)
    },
    internationalOrCustom({commit},res){
      commit('SET_IS_INTERNATIONAL_OR_CUSTOM',res)
    },
    passedTL({commit}){
      commit('IS_PASSED_TL',true)
    },
    openSpecialAchiMedals({commit},res){
      commit('SET_SPECIAL_ACHI_MEDALS',res)
    },
    setTuEyeProtectionMode({commit}, res) {
      commit('SET_TU_EYE_PROTECTION_MODE', res)
    },
    setChristmasDialog({commit}, res) {
      commit('SET_CHRISTMAS_DIALOG', res)
    },
    addTuModelClickLogFun({},res){
      addTuModelClickLog(res)
    }
  },
  getters:{
    growthSystemScoreProgress:(state,getters)=>{
      if(state.growthSystemLevel==0){
        return 0
      }else if(state.growthSystemLevel==1){
        let p = getters.growthSystemTaskListCompletedLen/getters.growthSystemTaskListLength
        return p.toFixed(2)*100
      }else{
        const oneLevelTotalScore = getters.oneLevelTotalScore
        const levelAry = [0,0,oneLevelTotalScore,400,2500,8000,13500,20000,32000,320000]
        const score = state.growthSystemScore
        const level = state.growthSystemLevel
        let progress = 0;
        progress = (score-levelAry[level])/(levelAry[level+1]-levelAry[level])*100
        return progress
      }
    },
    growthSystemTaskListLength:state=>{
      if(!state.growthSystemTaskList){
        return 0
      }
      let len = 0;
      state.growthSystemTaskList.forEach((v)=>{
        len += v.TaskDataDetail.length
      })
      return len
    },
    growthSystemTaskListCompletedLen:state=>{
      if(!state.growthSystemTaskList){
        return 0
      }
      let len = 0;
      state.growthSystemTaskList.forEach((v)=>{
        v.TaskDataDetail.forEach((m)=>{
          if(m.Status==2 && m.ReceiveStatus==1) len+=1
        })
      })
      return len
    },
    oneLevelTotalScore:(state)=>{
      if(!state.growthSystemTaskList){
        return 0
      }
      let total = 0;
      state.growthSystemTaskList[0].TaskDataDetail.forEach(v=>{
        total += v.Score
      })
      return total
    },
    notReceivedList:state=>{
      if(!state.growthSystemTaskList){
        return []
      }
      let list = [];
      state.growthSystemTaskList.forEach((v)=>{
        v.TaskDataDetail.forEach((m)=>{
          if(state.growthSystemLevel==1){
            if(m.Status==2 && m.ReceiveStatus==0) list.push(m)
            else return list
          }else{
            if(m.Status==2 && m.ReceiveStatus==0) list.push(m)
          }
        })
      })
      return list
    }
  }
}

export default user
